export const equal = <T>(a: T, b: T) => {
  return a == b;
};

export const notEqual = <T>(a: T, b: T) => {
  return a != b;
};
